import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const SecondaryButton: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Button {...rest} variant="contained" color="secondary">
    {children}
  </Button>
);

export default SecondaryButton;
